import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_SETTINGS = {
  price_display: "R$ 19,90",
  checkout_url: "",
  cover_url: "",
  offer_heading:
    "O PASSADO NÃO PODE SER REESCRITO. MAS SEU PRÓXIMO CAPÍTULO AINDA PODE SER DIFERENTE.",
  offer_text:
    "Talvez você esteja buscando respostas. Talvez esteja buscando paz. Ou talvez deseje descobrir uma nova maneira de olhar para o amor, para a saudade e para as possibilidades de recomeço. Este e-book é um convite para iniciar essa jornada com espiritualidade, esperança e respeito.",
  support_contact: "",
  meta_pixel_id: "",
  google_ads_id: "",
};

const SettingsContext = createContext({ settings: DEFAULT_SETTINGS, loading: true });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((res) => setSettings({ ...DEFAULT_SETTINGS, ...res.data }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

export function priceValue(settings) {
  const raw = String(settings?.price_display || "").replace(/[^\d.,]/g, "");
  if (!raw) return undefined;
  const normalized = raw.includes(",") ? raw.replace(/\./g, "").replace(",", ".") : raw;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : undefined;
}
